{
    "Section_Header": "An Optionen senden:",
    "Section_SubHeader": "Berichte senden an:",
    "Validation_Valid_Domain_Name": "Die E-Mail-Adresse muss gültig sein.",
    "Validation_Valid_Same_As_User": "Die E-Mail-Adresse muss sich in derselben Domäne wie der aktuelle Benutzer befinden.",
    "Validation_Valid_Non_Blacklisted_Email": "Die E-Mail darf nicht von einer auf einer Blacklist stehenden Domain stammen.",
    "Validation_Valid_Max_Custom_Domains": "Sie können maximal {} benutzerdefinierte E-Mail-Adressen hinzufügen.",
    "Validation_Valid_Max_Entries": "Sie können nicht mehr als {} E-Mails haben.",
    "NAME": "ReportSchedulingEmails"
}